module.exports = __webpack_public_path__ + "static/media/productos-pro.4a6abc80.svg";